import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

const ButtonDrawer = (props) => {

  const {
    route,
    url,
    ico,
    title,
    listenChild,
    action

  } = props;

  const closeWindow = () => {
    listenChild(false);
  }

  let actionClick ;

  if (action){
    actionClick = action ;
  } else { actionClick = closeWindow }

  return (
    <>
      {route ? 
        <Link exact to={route}>
          <button onClick={actionClick} className="w-full h-full rounded-xs border-dashed border-2 border-gray-900">
            <div className="flex items-center">
              <div className="mx-auto">
                <FontAwesomeIcon icon={ico} className="mx-auto text-2xl text-indigo-600" />
                <div className="font-bold text-sm tracking-tight">{title}</div>
              </div>
            </div>
          </button>
        </Link>
        :
          url ?
            <a href={url} target='blank'>
              <button onClick={actionClick} className="w-full h-full rounded-xs border-dashed border-2 border-gray-900">
                <div className="flex items-center">
                  <div className="mx-auto">
                    <FontAwesomeIcon icon={ico} className="mx-auto text-2xl text-indigo-600" />
                    <div className="font-bold text-sm tracking-tight">{title}</div>
                  </div>
                </div>
              </button>
            </a>
          : null
      }
    </>
  );
}

export default ButtonDrawer;
